import { ChangeAgreementForm } from 'views/SingleCustomer/helpers/changeAgreementValues'
import { MaintenanceOrder } from '../types/service.types'
import buildParams from '../utils/utils/buildParams'
import {
  AgreementConflictsResponse,
  AgreementConflictType,
  CustomerAgreement,
  CustomerHistoryItem,
  CustomerOrder,
  CustomerPersonalInfo,
  CustomerTableResponse,
} from '../views/Customers/types/customer-filters.types'
import { ChangeCustomerInfoFormType } from '../views/SingleCustomer/helpers/getFormSchema'
import { RequestType } from '../views/SingleRequestPage/types/Request.type'
import { apiRequest, getUrl } from './ApiService'
import { ImpossibleReason } from './types/api.types'

export const CUSTOMERS_KEYS = {
  GET_CUSTOMERS: 'customers-table',
  GET_CUSTOMER_INFO: 'get-customer-info',
  GET_AGREEMENTS: 'get-customer-agreements',
  GET_HISTORY: 'get-customer-history',
  RELINK_AGREEMENT: 'relink-agreement',
  GET_ORDERS: 'customer-orders-table',
  GET_AGREEMENT_CONFLICTS: 'get-agreement-conflicts',
}

export const getCustomers = (params: any): Promise<CustomerTableResponse> => {
  const queryStingParams = buildParams(params)
  return apiRequest({
    url: getUrl(`/customers/paged?${queryStingParams}`),
    method: 'GET',
  })
}

export const getCustomerInfo = (id: string): Promise<CustomerPersonalInfo> => {
  return apiRequest({
    url: getUrl(`/customers/${id}/info`),
    method: 'GET',
  })
}

export const getCustomerAgreement = (
  id: string | number,
  orderId?: string | number,
  serviceOrderId?: string | number,
): Promise<CustomerAgreement[]> => {
  const query = orderId ? `installationOrderId=${orderId}` : ''
  const query2 = serviceOrderId ? `maintenanceOrderId=${serviceOrderId}` : query

  return apiRequest({
    url: getUrl(`/customers/${id}/agreements?${query2}`),
    method: 'GET',
  })
}

export const editCustomerAgreement = (
  id: string | number,
  data: ChangeAgreementForm,
) => {
  return apiRequest({
    url: getUrl(`/agreements/${id}`),
    method: 'PATCH',
    jsonBody: data,
  })
}

export const getCustomerHistory = (
  id: string,
): Promise<CustomerHistoryItem[]> => {
  return apiRequest({
    url: getUrl(`/customers/${id}/history`),
    method: 'GET',
  })
}

export const getCustomerOrders = (id: string): Promise<CustomerOrder[]> => {
  return apiRequest({
    url: getUrl(`/customers/${id}/orders`),
    method: 'GET',
  })
}

export const getSingleRequest = (id: string): Promise<RequestType> => {
  return apiRequest({
    url: getUrl(`/orders/${id}`),
    method: 'GET',
  })
}

export const getSingleServiceRequest = (
  id: string,
): Promise<MaintenanceOrder> => {
  return apiRequest({
    url: getUrl(`/maintenance/maintenanceorders/${id}`),
    method: 'GET',
  })
}

export const assignDealerEquipmentCheck = (params: {
  orderIds: number[]
  dealerId: string
}): Promise<void> => {
  return apiRequest({
    url: getUrl(`/customers/orders/sat-recovery-campaign/assign`),
    method: 'POST',
    jsonBody: params,
  })
}

export const getEquipmentCheckHistory = (
  id: string,
): Promise<CustomerHistoryItem[]> => {
  return apiRequest({
    url: getUrl(`/customers/orders/sat-recovery-campaign/${id}/history`),
    method: 'GET',
  })
}

export const assignDealerSingle = (body: {
  OrderId: number
  DealerId: string
}): Promise<void> => {
  return apiRequest({
    url: getUrl(`/maintenance/maintenanceorders/maintenance/assign`),
    method: 'POST',
    jsonBody: body,
  })
}

export const takeEquipmentCheckRequests = (params: number[]): Promise<void> => {
  return apiRequest({
    url: getUrl(`/customers/orders/sat-recovery-campaign/begin-processing`),
    method: 'POST',
    jsonBody: params,
  })
}

export const completeEquipmentCheckRequests = (
  params: number[],
): Promise<void> => {
  return apiRequest({
    url: getUrl(`/customers/orders/sat-recovery-campaign/complete-processing`),
    method: 'POST',
    jsonBody: params,
  })
}

export const editCustomerInfo = (
  customerId: number,
  body: ChangeCustomerInfoFormType,
): Promise<void> => {
  return apiRequest({
    url: getUrl(`/customers/${customerId}/info`),
    method: 'PATCH',
    jsonBody: body,
  })
}

export const relinkCustomerAgreement = (
  agreementId: number,
  body: { customerId: number },
): Promise<void> => {
  return apiRequest({
    url: getUrl(`/agreements/${agreementId}/customer`),
    method: 'PATCH',
    jsonBody: body,
  })
}

export const getImpossibleReasons = (): Promise<ImpossibleReason[]> => {
  return apiRequest({
    url: getUrl(`/maintenance/impossiblereasons`),
    method: 'GET',
  })
}

export const getAllConflicts = (): Promise<AgreementConflictType[]> => {
  return apiRequest({
    url: getUrl('/agreement-issues'),
    method: 'GET',
  })
}

export const getAgreementConflicts = (
  agreementId: number,
): Promise<AgreementConflictsResponse> => {
  return apiRequest({
    url: getUrl(`/agreements/${agreementId}/issues`),
    method: 'GET',
  })
}

export const setAgreementConflicts = (
  agreementId: number,
  body: number[],
): Promise<number[]> => {
  return apiRequest({
    url: getUrl(`/agreements/${agreementId}/issues`),
    method: 'PATCH',
    jsonBody: body,
  })
}

export const checkAddressExchange = (address: any) => {
  return apiRequest({
    url: getUrl('/orders/check-address-exchanges'),
    method: 'POST',
    jsonBody: address,
  })
}
